import { cn } from "@/lib/utils";

export type CardSpan = 1 | 2 | 3;

/**
 * Column span for fields inside the card content grid (`grid-cols-3`).
 * Spans are unconditional — no container query — so they work at any card width,
 * including 5-across layouts on wide monitors where container queries previously
 * failed to fire.
 */
export function getCardFieldGridColClass(span?: CardSpan): string {
  const s = span ?? 3;
  const map: Record<CardSpan, string> = {
    1: "col-span-1",
    2: "col-span-2",
    3: "col-span-3",
  };
  return map[s];
}

/** Wrapper class for each card field cell (grid + min width). */
export function cardFieldCellClass(span?: CardSpan, className?: string): string {
  return cn("min-w-0", getCardFieldGridColClass(span), className);
}
